import { ModBusSignal, } from 'z3k-config';
export function createModBusSignal(new_signal) {
    return {
        ...ModBusSignal.default_object,
        ...new_signal,
        id: new_signal.id,
    };
}
export function createWiredTemperatureSensor(new_sensor) {
    return {
        ...new_sensor,
        id: new_sensor.id,
        io_extension_id: new_sensor.io_extension_id,
    };
}
export function createOutputAction(new_action) {
    return {
        ...new_action,
        id: new_action.id,
    };
}
export function createAnalogOutput(new_output) {
    return {
        ...new_output,
        id: new_output.id,
    };
}
export function createAnalogInput(new_input) {
    return {
        ...new_input,
        id: new_input.id,
        calibration: new_input.calibration,
    };
}
export function createWebElement(new_el) {
    return {
        ...new_el,
        id: new_el.id,
        id_active: new_el.id_active,
        id_passive: new_el.id_passive,
    };
}
export function createCalibrationTable(new_radio) {
    return {
        ...new_radio,
        id: new_radio.id,
    };
}
export function createUIGroup(new_group) {
    return {
        ...new_group,
        id: new_group.id,
        items: new_group.items,
    };
}
